import { HTTP_INTERCEPTORS } from '@angular/common/http';
import {
	PublicClientApplication,
	InteractionType,
	BrowserCacheLocation,
	LogLevel,
	Configuration
} from '@azure/msal-browser';
import {
	MsalGuard,
	MsalInterceptor,
	MsalBroadcastService,
	MsalInterceptorConfiguration,
	MsalService,
	MSAL_GUARD_CONFIG,
	MSAL_INSTANCE,
	MSAL_INTERCEPTOR_CONFIG,
	MsalGuardConfiguration
} from '@azure/msal-angular';
import { environment } from '@environments/environment';
import { Provider } from '@angular/core';

export function loggerCallback(logLevel: LogLevel, message: string) {
	if (logLevel === LogLevel.Info) console.info(`📝 → ` + message);
	else console.info(`📝 → ` + message);
}
export function MSALInstanceFactory(): PublicClientApplication {
	return new PublicClientApplication({
		auth: {
			clientId: environment.msalConfig.clientId,
			authority: `https://login.microsoftonline.com/${environment.msalConfig.tenantId}`,
			postLogoutRedirectUri: '/',
			redirectUri: '/'
		},
		cache: {
			cacheLocation: BrowserCacheLocation.LocalStorage,
			storeAuthStateInCookie: true,
			cacheMigrationEnabled: true
		},
		system: {
			allowPlatformBroker: false,
			loggerOptions: {
				loggerCallback,
				logLevel: LogLevel.Error,
				piiLoggingEnabled: false
			}
		}
	});
}
export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
	const protectedResourceMap = new Map<string, Array<string>>();
	protectedResourceMap.set(environment.baseUrl, environment.msalConfig.scopes.custom || []);
	protectedResourceMap.set(environment.msalConfig.graphAddress, environment.msalConfig.scopes.graph || []);
	protectedResourceMap.set(environment.msalConfig.powerbiAddress, environment.msalConfig.scopes.powerbi || []);

	return {
		interactionType: InteractionType.Redirect,
		protectedResourceMap
	};
}
export function MSALGuardConfigFactory(): MsalGuardConfiguration {
	return {
		interactionType: InteractionType.Redirect,
		authRequest: {
			scopes: environment.msalConfig.scopes.custom || []
		},
		loginFailedRoute: '/auth/login'
	};
}

export const MsalProviders: Provider[] = [
	{
		provide: HTTP_INTERCEPTORS,
		useClass: MsalInterceptor,
		multi: true
	},
	{
		provide: MSAL_INSTANCE,
		useFactory: MSALInstanceFactory
	},
	{
		provide: MSAL_GUARD_CONFIG,
		useFactory: MSALGuardConfigFactory
	},
	{
		provide: MSAL_INTERCEPTOR_CONFIG,
		useFactory: MSALInterceptorConfigFactory
	},
	MsalService,
	MsalGuard,
	MsalBroadcastService
];
